<template>
  <div class="dropdown">
    <div class="dropdown__el" @click="$emit('show-details')">
      {{ $t("message.common.details") }}
    </div>
    <div class="dropdown__el" @click="$emit('show-reviews-list')">
      {{ $t("message.reviews.reviewsList") }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ReviewsCategoriesHeatmapDropdown"
};
</script>
<style lang="scss" scoped>
$dropdown-gray: rgba(54, 60, 86, 0.08);

.dropdown {
  background: white;
  position: absolute;
  z-index: 1;
  border-radius: 8px;
  border: 1px solid $dropdown-gray;
  box-shadow: 0px 0px 30px 0px $dropdown-gray;

  &__el {
    padding: $spacing * 1.5 $spacing * 2;
    cursor: pointer;
    @include font-size(14px);

    & + & {
      border-top: 1px solid $dropdown-gray;
    }

    &:hover {
      background: $dropdown-gray;
    }
  }
}
</style>
